<template>
  <div class="card">
    <div class="card-title" :class="[theme.text]">
      {{ row.title }}
    </div>
    <div class="card-rule" :class="[theme.text]">
      {{ row.rule }}
    </div>
    <div class="card-cost" :class="[theme.text]">
      {{ row.cost }}
    </div>
    <div class="card-divide">
      <el-divider></el-divider>
    </div>
    <div class="card-description">
      <div
        v-for="(description, index) in row.description"
        :key="index"
        class="description-term"
      >
        <div class="description-term-node">
          -
        </div>
        <div class="description-term-content">
          {{ description }}
        </div>
      </div>
    </div>
    <el-button class="card-button theme-button" :class="[theme.button]">
      {{ row.button }}
    </el-button>
  </div>
</template>
<script>
export default {
  computed: {
    theme() {
      if (this.row.theme === "blue") {
        return {
          text: "theme-text-blue",
          button: "theme-button-blue",
        };
      } else if (this.row.theme === "green") {
        return {
          text: "theme-text-green",
          button: "theme-button-green",
        };
      } else {
        return {
          text: "theme-text-default",
          button: "theme-button-red",
        };
      }
    },
  },
  props: {
    row: Object,
  },
  data() {
    return {};
  },
};
</script>

<style lang="sass" scoped>
.theme
  &-text
    &-default
      color: #515151
    &-blue
      color: #367BC1
    &-green
      color: #3EC3A3
  &-button
    &:hover
      color: $color-white
    &:focus
      color: $color-white
    &-blue
      background: transparent linear-gradient(270deg, #92BCE6 0%, #367BC1 100%) 0% 0% no-repeat padding-box
    &-green
      background: transparent linear-gradient(270deg, #AFEDDE 0%, #3EC3A3 100%) 0% 0% no-repeat padding-box
    &-red
      background: transparent linear-gradient(270deg, #F4B4B5 0%, #EF777A 100%) 0% 0% no-repeat padding-box


.card
  width: 324px
  box-shadow: 0px 3px 10px #00000029
  border-radius: 3px
  opacity: 1
  text-align: center
  color: #515151
  &-title
    display: inline-block
    margin-top: 35px
    font-weight: bold
    font-size: 24px
  &-rule
    margin-top: 20px
  &-cost
    font-weight: bold
    font-size: 24px
    margin-top: 28px
  &-divide
    width: 80%
    margin: 0px auto
    ::v-deep .el-divider--horizontal
      margin: 20px auto 0px
  &-description
    padding: 24px
  &-button
    width: 284px
    height: 56px
    margin: 12px auto
    border-radius: 5px
    font-size: 16px
    color: $color-white

.description
  &-term
    display: flex
    justify-content: flex-start
    font-size: 14px
    &:nth-child( n+2 )
      margin-top: 24px
    &-content
      margin-left: 8px
      text-align: left
</style>
